import { DECISION_LABEL } from '../components/DecisionTypeRadios';

// Shared everywhere an object's documentation status shows up — Arbejdskø's
// Fund view, the "Alle objekter" area lists, Beslutninger & risici, Noter.
// Four real states: no note at all, a note saved without picking a
// Beslutningstype (the field is optional, so this is genuinely "not decided
// yet"), an explicit "accepted" decision, or any other real decisionType
// shown by its own name instead of a flattened "Dokumenteret". Tones match
// the approved decision-type palette (see DecisionTypeRadios.jsx):
// accepted = blue, temp/Skal rettes = orange, compensating = turquoise,
// falsepos = grey. "resolved" is legacy (no longer offered as a choice).
const DECISION_TONE = { accepted: 'handled', resolved: 'ok', temp: 'exception', compensating: 'compensating', falsepos: 'neutral' };

export function getStatusBadge(note) {
  if (!note) return { label: 'Ingen beslutning', tone: 'neutral' };
  // A note written without choosing a decision type is only a comment on the object. Same for the
  // retired "resolved" ("Løst") type — it isn't one of NordComply's real decision types any more, so
  // a note still carrying it from before shows as a plain note, not a decision type that doesn't
  // actually exist to pick.
  if (!note.decisionType || note.decisionType === 'resolved') return { label: 'Generel note', tone: 'neutral' };
  return { label: DECISION_LABEL[note.decisionType] || 'Dokumenteret', tone: DECISION_TONE[note.decisionType] || 'handled' };
}
